<template>
    <nav class="menu-bar" :aria-label="t('menus.mobile_bottom_nav')">
        <ul class="menu-list">
            <li
                v-for="item in menusBarList"
                :key="item.key"
                class="menu-item"
                :class="{
                    'is-active': isActive(item),
                    'is-create': item.isCreate,
                }"
            >
                <NuxtLink class="menu-link " :to="item.path"
                >
                   
                    <span
                        class="icon-wrap  "
                        :class="{ 'is-create': item.isCreate }"
                    >
                        <span class="icon" :class="item.icon" />
                    </span>
                    <span v-if="!item.isCreate" class="label">{{
                        item.name
                    }}</span>
                </NuxtLink>
            </li>
        </ul>
    </nav>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from '#imports'
import { useI18n } from '~/composables/useI18n'
import { deleteLangPrefix } from '~/utils/common'

type MenuItem = {
    key: string
    icon: string
    name: string
    path: string
    isCreate?: boolean
    match?: (path: string) => boolean
}

const route = useRoute()
const { t } = useI18n()

const menusBarList = computed<MenuItem[]>(() => [
    {
        key: 'home',
        icon: 'i-mobile-home-icon',
        name: t('menus.footer_home'),
        path: '/',
        match: p => p === '/',
    },
    {
        key: 'explore',
        icon: 'i-mobile-explore-icon',
        name: t('menus.explore'),
        path: '/explore',
        match: p => p === '/explore' || p.startsWith('/explore/') || p === '/characters' || p.startsWith('/characters/'),
    },
    {
        key: 'create',
        icon: 'i-mobile-create-icon',
        name: t('menus.createNew'),
        path: '/history',
        isCreate: true,
        match: p => p === '/history' || p.startsWith('/history/'),
    },
    {
        key: 'shop',
        icon: 'i-mobile-laboratory-icon',
        name: t('menus.laboratory'),
        path: '/laboratory',
        match: p => p === '/photo-effects' || p.startsWith('/photo-effects/') || p ==='/video-effects' || p.startsWith('/video-effects/') || p ==='/ai-tools' || p.startsWith('/ai-tools'),
    },
    {
        key: 'me',
        icon: 'i-mobile-profile-icon',
        name: t('characterToImg.me'),
        path: '/my-creations',
        match: p => p === '/my-creations' || p.startsWith('/my-creations/'),
    },
])

const isActive = (item: MenuItem) => {
    const currentPath = deleteLangPrefix(route.path) || '/'

    return item.match ? item.match(currentPath) : currentPath === item.path
}
</script>

<style scoped lang="less">
.menu-bar {
    z-index: 49;
    width: 100vw;
    height: calc(64px + env(safe-area-inset-bottom, 0px));
    padding-bottom: env(safe-area-inset-bottom, 0px);
    border-top: 1px solid rgba(255, 255, 255, 0.05);
    background: #000;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
}

.menu-list {
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0;
    padding: 0 10px;
    list-style: none;
}

.menu-item {
    flex: 1 1 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.menu-link {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    text-decoration: none;
    color: #52525b;
    -webkit-tap-highlight-color: transparent;
}

.menu-item.is-active .menu-link {
    color: #fff;
}

.icon-wrap {
    width: 22px;
    height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.icon {
    width: 20px;
    height: 20px;
}

.label {
    font-size: 10px;
    line-height: 10px;
    letter-spacing: 0.2px;
}

.menu-item.is-create .menu-link {
    width: 48px;
    height: 48px;
    border-radius: 9999px;
    background: #1F2128;
    border: 4px solid #0d0e12;
    box-shadow:
        0 10px 15px -3px rgba(0, 0, 0, 0.1),
        0 4px 6px -4px rgba(0, 0, 0, 0.1);
}

.menu-item.is-create.is-active .menu-link {
    color: #000;
    box-shadow:
        0 12px 26px rgba(0, 0, 0, 0.45),
        0 0 18px rgba(255, 255, 255, 0.18),
        inset 0 0 0 1px rgba(255, 255, 255, 0.22);
    color: #000;
    background: #fff;
}

.menu-item.is-create .icon-wrap {
    width: 26px;
    height: 26px;
}

.menu-item.is-create .icon {
    width: 26px;
    height: 26px;
}

 

.i-mobile-home-icon {
    mask: url('~/assets/images/mobile/home.svg') no-repeat center;
    mask-size: contain;
    -webkit-mask: url('~/assets/images/mobile/home.svg') no-repeat center;
    -webkit-mask-size: contain;
    background-image: none;
    background-color: currentColor;
}
.i-mobile-explore-icon {
    mask: url('~/assets/images/common/Component 1.svg') no-repeat center;
    mask-size: contain;
    -webkit-mask: url('~/assets/images/common/Component 1.svg') no-repeat center;
    -webkit-mask-size: contain;
    background-image: none;
    background-color: currentColor;
}
.i-mobile-create-icon {
    mask: url('~/assets/images/mobile/create.svg') no-repeat center;
    mask-size: contain;
    -webkit-mask: url('~/assets/images/mobile/create.svg') no-repeat center;
    -webkit-mask-size: contain;
    background-image: none;
    background-color: currentColor;
}
.i-mobile-shop-icon {
    mask: url('~/assets/images/mobile/shop.svg') no-repeat center;
    mask-size: contain;
    -webkit-mask: url('~/assets/images/mobile/shop.svg') no-repeat center;
    -webkit-mask-size: contain;
    background-image: none;
    background-color: currentColor;
}
.i-mobile-laboratory-icon {
    mask: url('~/assets/images/mobile/toolkit.svg') no-repeat center;
    mask-size: contain;
    -webkit-mask: url('~/assets/images/mobile/toolkit.svg') no-repeat center;
    -webkit-mask-size: contain;
    background-image: none;
    background-color: currentColor;
}
.i-mobile-profile-icon {
    mask: url('~/assets/images/mobile/profile.svg') no-repeat center;
    mask-size: contain;
    -webkit-mask: url('~/assets/images/mobile/profile.svg') no-repeat center;
    -webkit-mask-size: contain;
    background-image: none;
    background-color: currentColor;
}
</style>
